import { Component } from '@angular/core';

@Component({
  selector: 'app-state-master',
  templateUrl: './state-master.component.html',
  styleUrls: ['./state-master.component.css'],
})
export class StateMasterComponent {
  title = 'AdminPanel';
  title1 = 'State <span>Master</span> ';
  title2 = 'Language  <span>Master</span>';
  title3 = 'Add new State';
  title4 = 'Add new  Language';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
  showAddModel: boolean = false;
  showAddModelB: boolean = false;
  toggleModel() {
    this.showAddModel = !this.showAddModel;
  }
  toggleModelB() {
    this.showAddModelB = !this.showAddModelB;
  }
  toggleModelc() {
    alert('dddddddd');
  }
}
